var ResourceManage = function () { return import('~/pages/resource_manage/resource-manage.vue'); };
export default [
    {
        path: '/resource_manage/resource-manage',
        name: 'resource-manage',
        component: ResourceManage
    }
];
